<template>
    <div class="online-help-detail-page">
        <div class="online-help-detail-page__shell">
            <div class="online-help-detail-page__header">
                <button class="btn btn-sm btn-success btn-square online-help-detail-page__back" @click="$router.push({ name: 'online_help' })">
                    <feather type="chevron-left" />
                </button>
                <div class="online-help-detail-page__hero">
                    <div class="online-help-detail-page__icon">
                        <feather :type="getModuleTypeIcon(module)" />
                    </div>
                    <div>
                        <span class="online-help-detail-page__eyebrow">Assistance</span>
                        <h5 class="title online-help-detail-page__title">
                            {{ $tl("labels.routes.onlineHelp") }} - {{ getModuleTypeLabel(module) }}
                            <ShowNewBadgeDetails class="ms-2" badge_uuid="a644c6f5-8bc3-48e8-be08-124398dfa9e1" />
                        </h5>
                    </div>
                </div>
            </div>

            <LoaderComponent class="mx-auto" v-if="loading" />
            <div v-else-if="videosList.length > 0" class="online-help-detail-page__list">
                <article class="online-help-video-card" v-for="video in videosList" :key="video.id">
                    <div class="online-help-video-card__main">
                        <div class="online-help-video-card__body">
                            <h6>{{ video.title }}</h6>
                            <p v-if="video.description" v-html="formatDescription(video.description)"></p>
                            <small>{{ $t("labels.videos.addedOn", { date: displayDate(video.created_at) }) }}</small>
                        </div>
                        <button class="btn btn-success btn-sm btn-circle online-help-video-card__toggle" @click="video.show = !video.show">
                            {{ video.show ? $tl("labels.videos.hide") : $tl("labels.videos.show") }}
                        </button>
                    </div>
                    <div class="online-help-video-card__player" v-if="video.show">
                        <ShowYoutubeVideo
                            class="online-help-video-card__youtube"
                            :youtubeVideoId="video.youtube_video_id"
                            :title="video.title"
                            width="100%"
                            height="380" />
                    </div>
                </article>
            </div>
            <div v-else class="online-help-detail-page__empty">{{ $tl("labels.videos.emptyForModule") }}</div>
        </div>
    </div>
</template>
<script>
import LoaderComponent from "../../../components/LoaderComponent.vue";
import ModuleTypesEnum from "../../../mixins/enums/ModuleTypesEnum";
import ShowYoutubeVideo from "../../../components/videos/ShowYoutubeVideo.vue";
import ShowNewBadgeDetails from "../../../components/NewBadges/showNewBadgeDetails.vue";

export default {
    data() {
        return {
            loading: false,
            videosList: [],
        };
    },
    mixins: [ModuleTypesEnum],
    methods: {
        fetchVideos() {
            this.loading = true;

            axios
                .get(`/api/videos?module=${this.module}`)
                .then((response) => {
                    this.videosList = response.data.data.map((video) => {
                        return {
                            ...video,
                            show: false,
                        };
                    });
                })
                .catch((error) => {
                    this.notifyError(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatDescription(description) {
            if (description === null || description === undefined) {
                return undefined;
            }
            return this.escapeHtml(description).replace(/\n/g, "<br/>");
        },
    },
    computed: {
        module() {
            return this.$route.params.module;
        },
    },
    components: {
        LoaderComponent,
        ShowYoutubeVideo,
        ShowNewBadgeDetails,
    },
    created() {
        this.fetchVideos();
    },
};
</script>

<style scoped>
.online-help-detail-page {
    min-height: calc(100vh - 72px);
    padding: 28px 18px 40px;
    background: linear-gradient(180deg, #f7fbfc 0%, #eef8fa 100%);
}

.online-help-detail-page__shell {
    max-width: 1080px;
    margin: 0 auto;
}

.online-help-detail-page__header {
    display: flex;
    align-items: stretch;
    gap: 14px;
    margin-bottom: 18px;
}

.online-help-detail-page__back {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 29px;
    margin-top: 14px;
}

.online-help-detail-page__hero {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    padding: 18px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
}

.online-help-detail-page__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 58px;
    flex: 0 0 58px;
    color: #fff;
    background: linear-gradient(145deg, #083e60, #0b5d87);
    border-radius: 15px;
    box-shadow: 0 12px 24px rgba(8, 62, 96, 0.16);
}

.online-help-detail-page__icon .feather {
    width: 27px;
    height: 27px;
}

.online-help-detail-page__eyebrow {
    display: inline-flex;
    margin-bottom: 8px;
    color: var(--main-color-light, #30a4b7);
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.online-help-detail-page__title {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
    color: #142f3c;
    font-size: 1.45rem;
    font-weight: 700;
}

.online-help-detail-page__list {
    display: grid;
    gap: 14px;
}

.online-help-video-card {
    padding: 20px 22px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
}

.online-help-video-card__main {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
}

.online-help-video-card__body {
    min-width: 0;
}

.online-help-video-card h6 {
    margin: 0;
    color: #173746;
    font-size: 1.08rem;
    font-weight: 800;
}

.online-help-video-card p {
    margin: 10px 0 0;
    color: #334e5a;
    line-height: 1.55;
}

.online-help-video-card small {
    display: inline-flex;
    margin-top: 12px;
    color: #7b8c95;
}

.online-help-video-card__toggle {
    flex: 0 0 auto;
    white-space: nowrap;
}

.online-help-video-card__player {
    margin-top: 18px;
    overflow: hidden;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 16px;
    background: #f4fafb;
}

.online-help-video-card__player :deep(iframe) {
    display: block;
    width: 100%;
    max-width: 100%;
}

.online-help-detail-page__empty {
    padding: 34px 20px;
    border: 1px solid rgba(48, 164, 183, 0.12);
    border-radius: 18px;
    color: #6c7f88;
    text-align: center;
    background: #fff;
    box-shadow: 0 18px 45px rgba(15, 58, 72, 0.07);
}

@media (max-width: 767.98px) {
    .online-help-detail-page {
        padding: 20px 12px 32px;
    }

    .online-help-detail-page__hero,
    .online-help-video-card__main {
        align-items: flex-start;
        flex-direction: column;
    }

    .online-help-detail-page__title {
        align-items: flex-start;
        flex-direction: column;
    }

    .online-help-video-card__toggle {
        align-self: flex-start;
    }
}
</style>
